import { useEffect, useState } from 'react'
import { useAuth } from '../../context/AuthContext'
import { saveTenantSettings } from '../../services/catalog/supabaseCatalog'
import { KITCHEN_BELLS, playKitchenBell, type KitchenBellKey } from '../../utils/kitchenBell'
import { Select } from '../Select'
import { BellRingIcon } from '../icons'
import './KitchenBellSetting.css'

/**
 * Mutfak ekranlarının yeni fiş zili (3 Kas 2026, kullanıcı): bütün kurum
 * için, bütün mutfak tabletleri aynı zili çalar. Seçince bir kez çalar ki
 * patron duymadan seçmesin.
 */
export function KitchenBellSetting({ readOnly = false }: { readOnly?: boolean }) {
  const { tenantId, kitchenBell } = useAuth()
  const [value, setValue] = useState<KitchenBellKey>(kitchenBell)
  const [error, setError] = useState<string | null>(null)
  useEffect(() => setValue(kitchenBell), [kitchenBell])

  const choose = async (next: string) => {
    const key = next as KitchenBellKey
    playKitchenBell(key)
    if (!tenantId || readOnly || key === value) return
    const prev = value
    setValue(key)
    setError(null)
    try {
      await saveTenantSettings(tenantId, { kitchenBell: key })
    } catch (err) {
      console.error('[settings] kitchen bell', err)
      setValue(prev)
      setError('Kaydedilemedi. İnternet bağlantınızı kontrol edin.')
    }
  }

  return (
    <div className="kbell">
      <div className="kbell__text">
        <div className="setting__label">Yeni sipariş zili</div>
        <div className="setting__hint">Mutfak ekranları yeni fiş gelince bunu çalar. Seçince bir kez dinletir.</div>
      </div>
      <div className="kbell__pick">
        <Select
          className="kbell__sel"
          value={value}
          disabled={readOnly}
          onChange={(v) => void choose(v)}
          options={KITCHEN_BELLS.map((b) => ({ value: b.key, label: b.name }))}
        />
        <button
          type="button"
          className="btn btn--outline kbell__play"
          onClick={() => playKitchenBell(value)}
          aria-label="Zili dinle"
          title="Dinle"
        >
          <BellRingIcon />
          Dinle
        </button>
      </div>
      {error && <p className="setting__error">{error}</p>}
    </div>
  )
}
